import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import useAdvanceStatements, {
  useAdvanceStatementsProps,
} from 'features/advance/hooks/useAdvanceStatements.hook';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import SectionedContentScreen from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import ErrorScreen from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

const MonthlyStatement = () => {
  const { statementId } = useLocalSearchParams<{
    statementId: string;
  }>();

  const props: useAdvanceStatementsProps = {
    year: statementId,
  };
  const { data, loading, errorModel } = useAdvanceStatements(props);
  return (
    <View style={styles.screen}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: `${statementId} statements`,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <SectionedContentScreen model={data} />
      <ScreenTransitionOverlay
        isLoading={loading}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={
          errorModel && !loading ? <ErrorScreen {...errorModel} /> : null
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    paddingVertical: theme.spacing.m,
  },
});

export default MonthlyStatement;
